import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { PointsSummaryFacade } from '@features/points-summary/facades/points-summary-facade/points-summary.facade';
import { SideNavComponent } from '@rd/core/components/side-nav/side-nav.component';
import { NavLinksService } from '@rd/core/services/dropdown-link-items/nav-links.service';
import { UrlUtilsService } from '@rd/core/services/url-utils/url-utils.service';
import { AuthRenderState, NavLink, PointsSummary } from '@rd/types';
import { isExternalUrl } from '@rd/utils/url.utils';
import { Observable } from 'rxjs';
import { StarNavLinksService } from '../../services/star-nav-links/star-nav-links.service';

type UserAction = 'login' | 'logout' | 'enroll' | 'changePassword';

@Component({
  selector: 'star-core-side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StarSideNavComponent extends SideNavComponent implements OnInit {
  @HostBinding('class.star-core-side-nav') componentClass = true;
  @Output() sideNavClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() userAction: EventEmitter<UserAction> =
    new EventEmitter<UserAction>();

  starNavLinks: NavLink[];
  menuExpanded = false;

  pointsSummary$: Observable<PointsSummary | null> =
    this.pointsSummaryFacade.pointsSummary$;

  constructor(
    protected navLinksService: NavLinksService,
    protected urlUtilsService: UrlUtilsService,
    private pointsSummaryFacade: PointsSummaryFacade,
    private router: Router,
    private starNavLinksService: StarNavLinksService,
  ) {
    super(navLinksService, urlUtilsService);
  }

  ngOnInit(): void {
    this.starNavLinks = this.starNavLinksService.nonLoggedInLinks;
  }

  get componentRenderState(): AuthRenderState {
    return this.authRenderState;
  }

  closeSideNav(): void {
    this.sideNavClose.emit();
  }

  redirectToAndCloseSideNav(url: string): void {
    this.closeSideNav();
    this.router.navigateByUrl(url);
  }

  enrollEmit(): void {
    this.closeSideNav();
    this.userAction.emit('enroll');
  }

  loginEmit(): void {
    this.closeSideNav();
    this.userAction.emit('login');
  }

  logoutEmit(): void {
    this.closeSideNav();
    this.userAction.emit('logout');
  }

  changePasswordEmit(): void {
    this.closeSideNav();
    this.userAction.emit('changePassword');
  }

  isExternalNavLink(linkItem: NavLink): boolean {
    return isExternalUrl(linkItem.route.toString());
  }

  toggleMenu(): void {
    this.menuExpanded = !this.menuExpanded;
  }
}
